export default {
  commonPapersize: 'Common Papersizes',
  customerPapersize: 'Customer Papersize',
};
